import { css } from "@emotion/css";

export const styles = {
  tooltipWrapper: css({
    alignItems: "center",
    cursor: "pointer",
    display: "flex",
    flexGrow: 1,
    justifyContent: "center",
  }),
};
